document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-avatar-preview-input]');
    if (!input) {
        return;
    }

    const container = input.closest('[data-avatar-preview]');
    if (!container) {
        return;
    }

    const file = input.files?.[0];
    if (!file) {
        return;
    }

    const image = container.querySelector('[data-avatar-preview-image]');
    const initials = container.querySelector('[data-avatar-preview-initials]');

    const reader = new FileReader();
    reader.addEventListener('load', () => {
        if (image) {
            image.src = reader.result;
            image.classList.remove('hidden');
        }
        if (initials) {
            initials.classList.add('hidden');
        }
    });
    reader.readAsDataURL(file);
});
